import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { FooterService } from '../../../services/footer.service';
import { OperationEnum } from '../../../interfaces/operations.enum';

export interface FooterItem {
  iconName: string,
  displayNameTranslation: string,
  route: string,
  permission?: string,
  badgeValue?: number | null,
  linkedRoutes?: string[],
  userRoles?: string[],
  operationEnum?: OperationEnum,
  available?: (route: string) => boolean,
}

@Component({
  selector: 'app-footer-base',
  templateUrl: './footer-base.component.html',
  styleUrls: ['./footer-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class FooterBaseComponent implements OnInit {

  public footerItems: FooterItem[] = [];
  constructor(public router: Router, private cdr: ChangeDetectorRef, private footerService: FooterService) { }

  public ngOnInit(): void {

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.cdr.markForCheck();
    });


    this.footerService.footerItems.subscribe((footerItems: FooterItem[]) => {
      this.footerItems = footerItems;
      this.cdr.markForCheck();
    });
  }

  public navigateToRoute(route: string): void {
    this.router.navigate([route]);
  }

  public isFooterItemSelected(item: FooterItem): boolean {
    const currentRoute: string = this.getCurrentRoute();

    if (currentRoute.startsWith("/" + item.route)) {
      return true;
    }

    // Special case for group specific triggers
    if (currentRoute.startsWith("/triggers/layout-group") && item.route === "groups") {
      return true;
    }

    if (item.route === "dashboard" && currentRoute === "/") {
      return true;
    }

    if (item.linkedRoutes) {
      for (let i: number = 0; i < item.linkedRoutes.length; i++) {
        if (currentRoute.startsWith(item.linkedRoutes[i])) {
          // Special case for group specific triggers not highligting more
          if (currentRoute.startsWith("/triggers/layout-group") && item.route !== "groups") {
            return false;
          }
          else {
            return true;
          }
        }
      }
    }

    return false;
  }

  private getCurrentRoute(): string {
    // Remove params in url
    const currentRoute: string = this.router.url.split('?')[0];
    return currentRoute;
  }
}
